import React from "react";
import { FormGroup, ModalBody, ModalHeader, Input, Label, Button, Form } from "reactstrap";
import SimpleReactValidator from "simple-react-validator";
import { addInterest, updateInterest} from "../../../services/InterestService";
import { notifyError, notifySuccess } from "../../../utils/utils";
import Loader from "../../../utils/Loader";

class AddInterest extends React.Component {

    constructor(props){
        super(props);

        this.state = {
            interest: "",
            alertModel: false,
            alertMessage: "",
            loading: false
        };

        this.validator = new SimpleReactValidator({
            locale: 'en', messages:{}, autoForceUpdate: this,
            validators:{
                interest: {
                    message: "Interest contains only Alphabet, Numbers and Symbols ,-'[]()&",
                    rule: (val, params, validator) => {
                        return validator.helpers.testRegex(val,  /^[\w&.,'/\s/g\[\]()\-]+$/)
                    }
                }
            }
        });

        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleResponse = this.handleResponse.bind(this);
    }

    handleSubmit(e) {
        e.preventDefault();
        if(!this.validator.allValid()){
            this.validator.showMessages();
            this.forceUpdate();
            return;
        }
        const data = { name: this.state.interest};
        this.setState({ loading: true });
        if(this.props.isEditing) {
            updateInterest(this.state.id, data).then(res => this.handleResponse(res.data))
        } else {
            addInterest(data).then(res => this.handleResponse(res.data)); 
        }
    }

    handleResponse(data) {
        console.log(data);
        if(data.status) {
            notifySuccess(data.message);
            setTimeout(() => {
                this.props.toggle();
                this.props.reload();
            }, 1000);
        } else {
            this.setState({ loading: false });
            notifyError(data.message);
        }
    }

    componentDidMount(){
        if(this.props.isEditing){
            this.setState({
                interest: this.props.interest.name,
                id: this.props.interest.interested_on_id
            });
        }
    }

    render() {
        this.validator.purgeFields();

        const { interest } = this.state;

        return(

            <React.Fragment>
                {/* <div className="page-content">
                    <Container fluid> */}
                        <ModalHeader toggle={() => this.props.toggle()}> 
                            {this.props.isEditing ? "Edit" : "Add"} Interest
                        </ModalHeader>
                        <ModalBody>
                      
                            <Form onSubmit={this.handleSubmit} autoComplete="off">

                                <FormGroup>
                                    <Label>Interest</Label>
                                    <Input
                                        type="text"
                                        name="interest"
                                        value={interest}
                                        onChange={e => {
                                            this.setState({
                                                interest: e.target.value
                                            });
                                        }}
                                    />
                                <span className="text-danger">
                                    {this.validator.message('Interst', interest, 'required|min:2|max:30|interest')}
                                </span>
                                </FormGroup>

                                <FormGroup className="pull-right">
                                {
                                    this.state.loading
                                        ?
                                        <Loader />
                                        // <Spinner style={{ width: '3rem', height: '3rem' }}  color="primary" />
                                        :
                                        <Button color="success" type="submit">Submit</Button> 
                                }
                                </FormGroup>
                            </Form>
                        </ModalBody>
                    {/* </Container>
                </div> */}
            </React.Fragment>
        )
    }
}

export default AddInterest;